<script setup lang="ts">
import { type Area } from "@gasparigit/omnia-sdk";
import type { FieldProps } from "../ui/auto-form";

defineProps<
  FieldProps & {
    areas: Area[];
  }
>();
</script>

<template>
  <FormField v-slot="slotProps" :name="fieldName">
    <FormItem v-bind="$attrs">
      <AutoFormLabel v-if="!config?.hideLabel" :required="required">
        {{ config?.label }}
      </AutoFormLabel>
      <FormControl>
        <Select v-bind="slotProps" :model-value="slotProps.value?.toString()" @update:model-value="(v) => slotProps.setValue(parseInt(v))">
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem v-for="area in areas" :key="`area-${area.id}`" :value="`${area.id}`">{{ area.title }}</SelectItem>
          </SelectContent>
        </Select>
      </FormControl>
      <FormDescription v-if="config?.description">
        {{ config.description }}
      </FormDescription>
      <FormMessage />
    </FormItem>
  </FormField>
</template>
